<!--
 * @Descripttion: 报表字段设置
 * @Author: zenghua.wang
 * @Date: 2021-05-06 10:01:33
 * @LastEditors: zenghua.wang
 * @LastEditTime: 2022-04-07 10:50:19
-->
<template>
  <div>
    <el-form
      style="margin: 20px 0"
      ref="form"
      size="small"
      :model="form"
      :rules="rules"
      label-width="120px"
      label-suffix=":"
    >
      <el-form-item
        label="选择字段"
        prop="prop"
      >
        <el-select
          v-model="form.prop"
          clearable
          filterable
          allow-create
          default-first-option
          :popper-append-to-body="false"
          placeholder="请选择"
          @change="setFormProp"
        >
          <el-option
            v-for="item in feilds"
            :key="item"
            :label="item.label"
            :value="item"
            :disabled="item.disabled"
          >
          </el-option>
        </el-select>
        <div class="xa-form-tips">备注: 若没有可供选择的字段，可以手动输入！</div>
      </el-form-item>

      <el-form-item
        label="重命名"
        prop="label"
      >
        <el-input
          style="width: 188px"
          v-model="form.label"
          clearable
        ></el-input>
      </el-form-item>

      <el-form-item
        label="字段类型"
        prop="type"
      >
        <el-radio-group
          v-model="form.type"
          size="small"
        >
          <el-radio
            v-for="(item, index) in options.typeList"
            :key="index"
            :label="item.value"
          >{{ item.label }}</el-radio>
        </el-radio-group>
      </el-form-item>

      <el-form-item label="显示">
        <el-radio-group
          v-model="form.showType"
          size="mini"
        >
          <el-radio-button
            v-for="(item, index) in options.showList"
            :key="index"
            :label="item.value"
          >{{ item.label }}
          </el-radio-button>
        </el-radio-group>
      </el-form-item>

      <el-form-item label="列宽">
        <el-input
          style="width:188px"
          v-model="form.width"
          placeholder="请输入"
        />
        <div class="xa-form-tips">备注: 宽度支持为 auto 或者数字</div>
      </el-form-item>

      <el-form-item label="对齐方式">
        <el-radio-group
          v-model="form.align"
          size="mini"
        >
          <el-radio-button
            v-for="(item, index) in options.alignList"
            :key="index"
            :label="item.value"
          >{{ item.label }}</el-radio-button>
        </el-radio-group>
      </el-form-item>

      <el-form-item label="字体颜色">
        <el-color-picker
          v-model="form.color"
          :predefine="predefineColors"
        ></el-color-picker>
      </el-form-item>

      <el-form-item label="可排序">
        <el-switch
          v-model="form.sortable"
          :active-color="theme.active"
          :inactive-color="theme.inactive"
        />
      </el-form-item>

      <el-form-item label="合并列">
        <el-switch
          v-model="form.isColspan"
          :active-color="theme.active"
          :inactive-color="theme.inactive"
        />
      </el-form-item>

      <el-form-item label="搜索条件">
        <el-switch
          v-model="form.search"
          :active-color="theme.active"
          :inactive-color="theme.inactive"
        />
      </el-form-item>

      <el-form-item
        label="是否多选"
        v-if="form.type==='select'"
      >
        <el-switch
          v-model="form.multiple"
          :active-color="theme.active"
          :inactive-color="theme.inactive"
        />
      </el-form-item>

      <template v-if="selectType.includes(form.type)">
        <el-form-item label="下拉字典">
          <el-radio-group
            v-model="form.dicFrom"
            size="mini"
          >
            <el-radio-button
              v-for="(item, index) in options.selectList"
              :key="index"
              :label="item.value"
            >{{ item.label }}</el-radio-button>
          </el-radio-group>
        </el-form-item>

        <!-- 静态字典 -->
        <el-form-item
          label="静态字典"
          v-if="form.dicFrom === '静态'"
        >
          <dictory-select
            v-if="form.type === 'select'"
            :dicData="form.dicData"
            @change="updateDictory"
          />

          <dictory-cascader
            v-if="form.type === 'cascader'"
            :dicData="form.dicData"
            @change="updateDictory"
          />
        </el-form-item>

        <!-- 接口获取 -->
        <template v-if="form.dicFrom === '动态'">
          <el-form-item label="字典接口">
            <el-input
              v-model="form.dicUrl"
              clearable
              placeholder="请输入"
              style="width:500px"
            />
          </el-form-item>

          <el-form-item label="请求方式">
            <el-select
              style="width:188px"
              size="small"
              clearable
              placeholder="请选择"
              v-model="form.dicMethod"
            >
              <el-option
                v-for="(item,index) in options.methodList"
                :key="index"
                :label="item.label"
                :value="item.value"
              ></el-option>
            </el-select>
          </el-form-item>
        </template>
      </template>
    </el-form>
  </div>
</template>

<script>
import {
  predefineColors,
  component,
  theme
} from '@/dragComponents/model/default.js'
import { isEmpty } from '@/dragComponents/utils'

import dictorySelect from '@/dragComponents/config/dictory/select'
import dictoryCascader from '@/dragComponents/config/dictory/cascader'

export default {
  name: 'report-column',
  components: {
    dictorySelect,
    dictoryCascader
  },
  props: ['data', 'form', 'feilds'],
  data() {
    return {
      theme: theme,
      predefineColors: predefineColors,
      // 级联字典
      selectType: ['select', 'cascader'],
      rules: {
        prop: [{ required: true, message: '请选择字段', trigger: 'blur' }],
        type: [{ required: true, message: '请选择字段类型', trigger: 'blur' }]
      },
      options: {
        alignList: component.alignType,
        showList: [
          {
            value: 'show',
            label: '显示'
          },
          {
            value: 'hide',
            label: '隐藏'
          },
          {
            value: 'detail',
            label: '详情显示'
          }
        ],
        typeList: component.searchType,
        selectList: component.selectType,
        methodList: [
          {
            label: 'GET',
            value: 'GET'
          },
          {
            label: 'POST',
            value: 'POST'
          }
        ]
      }
    }
  },
  methods: {
    // 选择字段
    setFormProp(e) {
      if (isEmpty(e)) return
      let label = isEmpty(e.label) ? e : e.label
      if (isEmpty(e.label)) {
        this.$nextTick(() => {
          this.form.prop = label
        })
      } else {
        this.form.prop = label
      }
    },
    // 更新字典
    updateDictory(list) {
      this.form.dicData = list
    }
  }
}
</script>
